import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionsInterviews from '../../redux/modules/interviews';
import ListEntity from '../../components/ListEntity/List';
import Interview from '../../components/ListEntity/Entities/Interview';
import Modal from '../../components/Render/Modal/Modal';
import FormInterview from '../../forms/interview';
import LayoutSection from '../../components/layout-section';

class General extends PureComponent {
  state = { isOpenNews: false };

  getData() {
    this.props.getAction();
  }

  componentWillMount() {
    this.getData();
  }

  removeInterview(info) {
    if (info.id > 0) {
      const { getAction, delAction } = this.props;
      delAction(info.id).then(() => {
        getAction();
      });
    }
  }

  toggleOpenNewsModal(data = {}) {
    this.setState({ isOpenNews: !this.state.isOpenNews, data });
  }

  render() {
    const { interviews } = this.props;
    return (
      <div className="contacts-container container">
        <LayoutSection
          isFetching={interviews.isFetching}
          title="Interviews">
          <ListEntity
            number={3}
            component={Interview}
            removeAction={(index) => {
              this.removeInterview(interviews.values[index]);
            }}
            editAction={(index) => {
              this.toggleOpenNewsModal(interviews.values[index]);
            }}
            addAction={() => {
              this.toggleOpenNewsModal();
            }}
            values={interviews.values}/>
        </LayoutSection>
        <div className="contacts-container__modal">
          <Modal
            toogle={this.toggleOpenNewsModal.bind(this)}
            isOpen={this.state.isOpenNews}>
            <FormInterview
              defaultValues={this.state.data}
              close={this.toggleOpenNewsModal.bind(this)}
              contactType={this.state.contactType}/>
          </Modal>
        </div>
      </div>
    );
  }
}

General.propTypes = {};
General.defaultProps = {};

export default connect(
  (state) => {
    return {
      interviews: state.interviews
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: ActionsInterviews.get,
        delAction: ActionsInterviews.del
      }, dispatch);
  }
)(General);



// WEBPACK FOOTER //
// ./src/containers/news/News.js